import React, { useEffect } from 'react'

export default function AllLocations() {
    if (!localStorage.getItem('reloadGN')) {
        localStorage.setItem('reloadGN', 'true');
        window.location.reload();
    }
  return (
    <div className="w-full min-h-screen py-12">
        <div className="mxw">
            <div className="w-full h-fit py-4 text-left">
                <p className="text-3xl font-bold">Our Locations</p>
            </div>
        </div>
        <div className="mxw space-y-4 mt-4">
            <div className=" border border-gray-70 py-5 px-4 flex flex-col items-start justify-start space-y-4 rounded-xl">
                <h3 className="font-semibold">Store, Area 1</h3>
                <div className="">
                    <p>Opposite Galaxy Square, <br/>5th Street, Toronto <br/> Canada</p>
                </div>
                <div>
                    <p><span className="font-thin text-green-600">Open - closes 9:30 PM</span></p>
                </div>
            </div>
            <div className=" border border-gray-70 py-5 px-4 flex flex-col items-start justify-start space-y-4 rounded-xl">
                <h3 className="font-semibold">Store, Area 2</h3>
                <div className="">
                    <p>Opposite Galaxy Square, <br/>5th Street, Toronto <br/> Canada</p>
                </div>
                <div>
                    <p><span className="font-thin text-red-500">Closed - closed at 8:30 PM</span></p>
                </div>
            </div>
            <div className=" border border-gray-70 py-5 px-4 flex flex-col items-start justify-start space-y-4 rounded-xl">
                <h3 className="font-semibold">Store, Area 1</h3>
                <div className="">
                    <p>Opposite Galaxy Square, <br/>5th Street, Toronto <br/> Canada</p>
                </div>
                <div>
                    <p><span className="font-thin text-green-600">Open - closes 10:30 PM</span></p>
                </div>
            </div>
        </div>
    </div>
  )
}
